import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Duplicate = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Duplicate({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <>
      <path
        d='M13.75 3.75H4.25C3.97386 3.75 3.75 3.97386 3.75 4.25V13.75C3.75 14.0261 3.97386 14.25 4.25 14.25H5.5C5.77614 14.25 6 14.4739 6 14.75V15.25C6 15.5261 5.77614 15.75 5.5 15.75H4.25C3.14543 15.75 2.25 14.8546 2.25 13.75V4.25C2.25 3.14543 3.14543 2.25 4.25 2.25H13.75C14.8546 2.25 15.75 3.14543 15.75 4.25V5.5C15.75 5.77614 15.5261 6 15.25 6H14.75C14.4739 6 14.25 5.77614 14.25 5.5V4.25C14.25 3.97386 14.0261 3.75 13.75 3.75Z'
        fill={color}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.25 10.25C8.25 9.14543 9.14543 8.25 10.25 8.25H19.75C20.8546 8.25 21.75 9.14543 21.75 10.25V19.75C21.75 20.8546 20.8546 21.75 19.75 21.75H10.25C9.14543 21.75 8.25 20.8546 8.25 19.75V10.25ZM10.25 9.75H19.75C20.0261 9.75 20.25 9.97386 20.25 10.25V19.75C20.25 20.0261 20.0261 20.25 19.75 20.25H10.25C9.97386 20.25 9.75 20.0261 9.75 19.75V10.25C9.75 9.97386 9.97386 9.75 10.25 9.75Z'
        fill={color}
      />
    </>
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'duplicate-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Duplicate;
